var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWishlistHeartWhite = function SvgIconWishlistHeartWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_wishlist_heart_white_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_wishlist_heart_white_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m12 20.327-1.104-.993a123 123 0 0 1-4.112-3.876q-1.626-1.621-2.577-2.886t-1.329-2.307A6.2 6.2 0 0 1 2.5 8.15q0-2.13 1.436-3.564Q5.372 3.15 7.5 3.15q1.31 0 2.475.613Q11.14 4.375 12 5.519q.86-1.144 2.025-1.756A5.25 5.25 0 0 1 16.5 3.15q2.13 0 3.564 1.436Q21.5 6.022 21.5 8.15q0 1.072-.378 2.115t-1.329 2.307q-.95 1.265-2.572 2.886-1.62 1.62-4.117 3.876zm0-2.027q2.4-2.16 3.95-3.702t2.45-2.68 1.25-2.02T20 8.15q0-1.5-1-2.5t-2.5-1q-1.185 0-2.19.672t-1.59 1.87h-1.44q-.596-1.208-1.595-1.875A3.86 3.86 0 0 0 7.5 4.65q-1.49 0-2.495 1T4 8.15q0 .866.35 1.748.35.883 1.25 2.02t2.45 2.675T12 18.3"
  }))));
};
export default SvgIconWishlistHeartWhite;